import BaseApi from './base'

export default class Sso extends BaseApi {
  constructor(endpoint, redirectUrl, logoutUrl) {
    super(endpoint)

    this.redirectUrl = redirectUrl
    this.logoutUrl = logoutUrl
  }

  getLogoutUrl = () => this.logoutUrl
  getRedirectUrl = () => this.redirectUrl
  getUser = token => this.request(token, 'GET', '/me')

  static requestHeaders(authToken, additionalHeaders) {
    return BaseApi.requestHeaders(authToken, {
      'Authorization': `Bearer ${authToken.access_token}`,
      ...additionalHeaders,
    })
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/api/sso.js